// src/pages/ContactPage.js
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { db } from '../config/firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import VideoHero from '../components/shared/VideoHero';

// Atölye verileri ikonlarla güncellendi
const workshops = [
  {
    id: 'ws1',
    title: 'Workshop 1: What You Need to Know Before You Start Your Children’s Book',
    desc: 'Unsure if your Muslim kids’ book idea will actually work? Get clear on formats, markets and what publishers expect – before you write a word.',
    icon: 'bi-journal-bookmark'
  },
  {
    id: 'ws2',
    title: 'Workshop 2: A Publisher’s Mainstream Marketing Steps – Copy Them for Your Book',
    desc: 'Big publishers do not guess when or how to launch. Copy their proven campaign steps, but make them halal and realistic for your Muslim book.',
    icon: 'bi-megaphone'
  },
  {
    id: 'ws3',
    title: 'Workshop 3: Roles You Can Do in Children’s Publishing',
    desc: 'Children’s publishing isn’t just about authors and illustrators. Discover where your skills fit – editorial, design, sales, digital.',
    icon: 'bi-person-workspace'
  }
];

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: 'Manuscript',
    selectedWorkshop: '',
    message: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', msg: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', msg: '' });

    try {
      // Form verisini hazırla, eğer Workshop seçildiyse atölye bilgisini de ekle
      const dataToSubmit = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message,
        createdAt: serverTimestamp(),
        read: false 
      };

      if (formData.subject === 'Workshop') {
        dataToSubmit.selectedWorkshop = formData.selectedWorkshop;
      }

      // Veriyi Firestore'a kaydet
      await addDoc(collection(db, "contactMessages"), dataToSubmit);

      setStatus({ type: 'success', msg: 'Your message has been sent successfully! We will get back to you soon.' });
      setFormData({ name: '', email: '', phone: '', subject: 'Manuscript', selectedWorkshop: '', message: '' });
    } catch (error) {
      console.error("Error sending message: ", error);
      setStatus({ type: 'error', msg: 'Something went wrong. Please try again later.' });
    }
    setLoading(false);
  };

  const inputStyle = {
    borderColor: '#ced4da',
    boxShadow: 'none'
  };

  return (
    <>
      <Helmet>
        <title>Contact Us | Little Hibba</title>
        <meta name="description" content="Get in touch with Little Hibba regarding manuscripts, illustrations, events or general inquiries." />
      </Helmet>

      <VideoHero 
        title="Contact Us" 
        tagline="We'd love to hear from you. Let's start a conversation."
      />

      <section className="py-5" >
        <div className="container py-lg-4">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-xl-7">
              <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                <div className="bg-white p-4 p-md-5">
                  <div className="text-center mb-5">
                    <h2 className="fw-bold display-6 ls-tight">Send us a message</h2>
                    <p className="text-muted">Fill out the form below and our team will get back to you shortly.</p>
                  </div>
                  
                  {status.msg && (
                    <div className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-danger'} d-flex align-items-center mb-4 rounded-3`} role="alert">
                      {status.type === 'success' ? (
                        <i className="bi bi-check-circle-fill me-2 fs-5"></i>
                      ) : (
                        <i className="bi bi-exclamation-triangle-fill me-2 fs-5"></i>
                      )}
                      <div>{status.msg}</div>
                    </div>
                  )}
                  
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input 
                            type="text" 
                            className="form-control bg-light-subtle" 
                            id="floatingName"
                            name="name" 
                            placeholder="Your Name"
                            value={formData.name} 
                            onChange={handleChange} 
                            required 
                            style={inputStyle}
                          />
                          <label htmlFor="floatingName" className="text-muted">Full Name</label>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-floating">
                          <input 
                            type="email" 
                            className="form-control bg-light-subtle" 
                            id="floatingEmail"
                            name="email" 
                            placeholder="name@example.com"
                            value={formData.email} 
                            onChange={handleChange} 
                            required 
                            style={inputStyle}
                          />
                          <label htmlFor="floatingEmail" className="text-muted">Email Address</label>
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                        <div className="form-floating">
                          <select 
                            className="form-select bg-light-subtle" 
                            id="floatingSelect"
                            name="subject" 
                            value={formData.subject} 
                            onChange={handleChange}
                            style={inputStyle}
                          >
                            <option value="Manuscript">Manuscript</option>
                            <option value="Illustrator">Illustrator</option>
                            <option value="Events">Events</option>
                            <option value="Workshop">Workshop</option>
                            <option value="Something Else">Something Else</option>
                          </select>
                          <label htmlFor="floatingSelect" className="text-muted">Subject</label>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-floating">
                          <input 
                            type="tel" 
                            className="form-control bg-light-subtle" 
                            id="floatingPhone"
                            name="phone" 
                            placeholder="Phone"
                            value={formData.phone} 
                            onChange={handleChange}
                            style={inputStyle}
                          />
                          <label htmlFor="floatingPhone" className="text-muted">Phone (Optional)</label>
                        </div>
                      </div>

                      {/* Şartlı Workshop Seçimi Alanı */}
                      {formData.subject === 'Workshop' && (
                        <div className="col-12 mt-4">
                          <p className="text-muted mb-2 fw-medium">Please select a workshop:</p>
                          <div className="list-group">
                            {workshops.map((ws) => (
                              <label className="list-group-item d-flex gap-3 bg-light-subtle align-items-center" key={ws.id} style={{ cursor: 'pointer' }}>
                                <input 
                                  className="form-check-input flex-shrink-0" 
                                  type="radio" 
                                  name="selectedWorkshop" 
                                  value={ws.title} 
                                  checked={formData.selectedWorkshop === ws.title}
                                  onChange={handleChange}
                                  required={formData.subject === 'Workshop'}
                                  style={{ boxShadow: 'none', marginTop: '0' }}
                                />
                                <div className="w-100">
                                  <div className="d-flex justify-content-between align-items-center w-100">
                                    <strong className="text-dark pe-3">{ws.title}</strong>
                                    {/* İkonlar sağda mükemmel hizalanacak şekilde ayarlandı */}
                                    <i className={`bi ${ws.icon} text-secondary fs-4 flex-shrink-0`} style={{ minWidth: '32px', textAlign: 'center' }}></i>
                                  </div>
                                  <small className="d-block text-muted mt-1">{ws.desc}</small>
                                </div>
                              </label>
                            ))}
                          </div>
                        </div>
                      )}

                      <div className="col-12 mt-4">
                        <div className="form-floating">
                          <textarea 
                            className="form-control bg-light-subtle" 
                            placeholder="Leave a message here" 
                            id="floatingTextarea" 
                            name="message" 
                            style={{ height: '150px', ...inputStyle }}
                            value={formData.message} 
                            onChange={handleChange} 
                            required
                          ></textarea>
                          <label htmlFor="floatingTextarea" className="text-muted">Message</label>
                        </div>
                      </div>

                      <div className="col-12 mt-4">
                        <button 
                          type="submit" 
                          className="btn btn-dark w-100 py-3 rounded-pill fw-bold shadow-sm transition-all" 
                          disabled={loading}
                          style={{ letterSpacing: '0.5px' }}
                        >
                          {loading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Processing...
                            </>
                          ) : (
                            <>
                              Send Message <i className="bi bi-arrow-right ms-2"></i>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="text-center mt-4 text-muted small">
                <p>We respect your privacy. Your information is safe with us.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;